import React from 'react';
import { Table, Progress } from 'antd';

const SnapshotTable = ({ snapshot }) => {
    const columns = [
        {
            title: 'Symbol',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Weight',
            dataIndex: 'weight',
            key: 'weight',
            render: weight => <Progress percent={weight * 100} steps={5} format={percent => `${(percent).toFixed(2)}%`} />
        }
    ];

    return (
        <Table
            columns={columns}
            dataSource={snapshot}
            pagination={false}
            size="small"
            rowKey="id"
        />
    );
};

export default SnapshotTable;